import React, { useState, useEffect } from 'react';
import { Button, Container, Row, Col } from 'react-bootstrap';

const CookieConsent = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('cookieConsent');
        if (!consent) {
            setIsVisible(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookieConsent', 'true');
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div
            style={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.8)',
                color: 'white',
                padding: '15px 0',
                zIndex: 9999,
                fontSize: '14px',
            }}
        >
            <Container>
                <Row className="align-items-center">
                    <Col xs={12} md={8} className="text-center text-md-start mb-2 mb-md-0">
                        Este sitio utiliza cookies para mejorar su experiencia. Al continuar
                        navegando, usted acepta nuestro uso de cookies.
                    </Col>
                    <Col xs={12} md={4} className="text-center text-md-end">
                        <Button variant="outline-light" size="sm" onClick={handleAccept}>
                            Aceptar
                        </Button>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default CookieConsent;
